import gql from 'graphql-tag';

export const UPSERT_EQUIPMENT = gql`
  mutation UpsertEquipment($input: UpsertEquipmentInput!) {
    upsertEquipment(input: $input) {
      id
    }
  }
`;
